import type {
  TScannerCredentialField,
  TScannerCredentialFieldPayload,
} from '@/_core/entities/scanner-credential-fields/models/types';

type TBuildScannerCredentialFieldsPayloadField = Pick<
  TScannerCredentialField,
  'fieldKey' | 'value'
> &
  Partial<Pick<TScannerCredentialField, 'fieldType' | 'name'>>;

export function buildScannerCredentialFieldsPayload(
  fields: TBuildScannerCredentialFieldsPayloadField[],
  customFieldKey = 'custom'
): TScannerCredentialFieldPayload[] {
  return fields.map((field) => ({
    fieldKey: field.fieldKey,
    value: field.value,
    ...(field.fieldType === customFieldKey ? { name: field.name } : {}),
  }));
}
